import { TakebackData, TakebackInboundSelectDialogProps } from '../../../types/inbound'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import React from 'react'
import { ScrollPanel } from 'primereact/scrollpanel'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const TakebackInboundDialog = (props: TakebackInboundSelectDialogProps) => {
    const { t } = useTranslation()
    const footer = () => {
        return (
            <>
                <Button
                    className="w-full p-button-secondary"
                    label={t(tokens.common.close)}
                    size="large"
                    onClick={() => props.onHide && props.onHide()}
                />
            </>
        )
    }

    const onClickSelectTakebackNo = (takeback: TakebackData) => {
        props.selectedData && props.selectedData(takeback)
    }

    return (
        <Dialog
            header={t(tokens.common.list_of_recovery_codes)}
            visible={props.visible}
            onHide={() => props.onHide && props.onHide()}
            closable={false}
            contentClassName="pb-0"
            footer={footer}
        >
            <div className="grid">
                <div className="col-12 flex text-lg p-0">
                    <ScrollPanel style={{ height: '300px' }}>
                        {props.info &&
                            props.info.map((data) => {
                                return (
                                    <Button
                                        key={data.seq}
                                        label={data.tkbckNo}
                                        className="w-full mt-2"
                                        severity="secondary"
                                        outlined
                                        onClick={() => onClickSelectTakebackNo(data)}
                                    />
                                )
                            })}
                    </ScrollPanel>
                </div>
            </div>
        </Dialog>
    )
}

export default TakebackInboundDialog
